
import axiosInstance from '../../../../config/axiosInstance';
import { LockReleaseValidation } from "../../views/LockRelease/Validation/LockReleaseValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
  const formErrors = LockReleaseValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      
      const token = localStorage.getItem('token');
      if (!token || token=="null") {
          redirectCallback();
          return; // Return early to prevent further execution
      }
      debugger;
      const CompanyID=localStorage.getItem("CompanyID");
      formData.ClientID=CompanyID;
      const response = await axiosInstance.post(`/Setup/CreateLockRelease`, formData);
      return  response.data;
     
     
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };